// The interface return value data cannot be this, otherwise the request will be judged as a failure
export const errorResult = '__ERROR_RESULT__';
